import React from 'react';
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from "@mui/icons-material/Delete";
import CloudDownload from "@mui/icons-material/CloudDownload";


const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const UploadDocumentsTable = props => {
  const classes = useStyles();
  const {
    rows = [],
    columns = [],
    onDelete = fn => fn,
    onDownload = fn => fn,
    type = 0,
  } = props;

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            {columns.map((column, i) => (
              <TableCell style={column.style} key={i}>{column.label}</TableCell>
            ))}
            <TableCell style={{
              width: '20%'
            }} align="center">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index}>
              {columns.map((column) => (
                <TableCell key={column.key} component="th" scope="row">
                  {row[column.key]}
                </TableCell>
              ))}
              <TableCell align="center">
                <IconButton onClick={() => onDownload(row.fileName)} size="large">
                  <CloudDownload fontSize="small" />
                </IconButton>
                <IconButton
                  onClick={() => onDelete(type === 0 ? row.id : row.documentId)}
                  size="large">
                  <DeleteIcon fontSize="small" />
                </IconButton></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {rows.length <= 0 && <Paper style={{
        display: 'flex',
        justifyContent: 'center',
        padding: 50
      }}>No Data</Paper>}
    </TableContainer >
  );
}

UploadDocumentsTable.propTypes = {
  rows: PropTypes.array,
  onDelete: PropTypes.func,
  onDownload: PropTypes.func,
  columns: PropTypes.array,
  type: PropTypes.number
};

export default UploadDocumentsTable;